import * as React from "react";
import { GroupedCardItem } from "@grandvisionhq/content";
import { Container, Heading } from "@grandvisionhq/elements";
import { compose } from "@grandvisionhq/utils";
import { useBloomreachGroupCardsData } from "../../../../hooks/hooks/use-bloomreach-group-cards-data.js";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const CmsGroupedCards = () => {
  const groupCardsData = useBloomreachGroupCardsData();
  if (!groupCardsData) return null;
  return /* @__PURE__ */ React.createElement(Container, { className: "group-cards", "data-t": "group-cards" }, /* @__PURE__ */ React.createElement(Heading, { component: "h2", variant: "small" }, groupCardsData.title), groupCardsData.cards.map((item, index) => /* @__PURE__ */ React.createElement(React.Fragment, { key: index }, /* @__PURE__ */ React.createElement(
    GroupedCardItem,
    {
      icon: item.icon,
      header: item.header,
      content: item.content,
      url: item.url,
      urlText: item.urlText
    }
  ))));
};
const GroupedCards = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsGroupedCards);
export {
  CmsGroupedCards,
  GroupedCards as default
};
//# sourceMappingURL=GroupedCards.js.map
